import { render, staticRenderFns } from "./ChargebackTable.vue?vue&type=template&id=3a2a03ea"
import script from "./ChargebackTable.vue?vue&type=script&lang=js"
export * from "./ChargebackTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports